export default __webpack_public_path__ + "static/media/redo.7448f554.svg";